// @TODO: i18n
/* @TODO: {
  add section for spritz (but rename it)
} */
/**
 * Ryan O'Dowd
 * 2021-07-05
 * © Copyright 2021 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  DISCOVER_ROUTE,
  FEEDBACK_CHAT_ROUTE,
  FRIENDS_ROUTE,
  HELP_ROUTE,
  LINK_ACCOUNT_ROUTE,
  PROFILE_ROUTE,
  SETTINGS_ROUTE,
} from '@utils/store/actions';
import {
  Linking,
  TouchableOpacity,
  View,
} from 'react-native';
import React from 'react';
import Text from '@components/common/Text';

// @TODO: images can be added to a lot of these (animated gifs) to make it easier to understand (host these on wrink.ly, though, so that the bundle size of the app doesn't bloat...and make sure there are two sets--one for android, and one for ios
// @TODO: add help docs for partners (only visible if they're logged in, and put at the top of the docs...actually, make them tab nav)
// @TODO: add a attribute on questions that should be available on the tips widgets
// @TODO: do styles really need to be passed down? can't they be defined here?
const faqs = (styles, navigation, isAnonymousUser, oakUser) => { // @TODO: do these need to be passed in?
  return {// @TODO: does isAnonymousUser need to be passed in?
    sections: [
      {
        title: 'Getting Started',
        data: [
          {
            question: 'The basics',
            answer: (
              <View>
                <Text style={styles.paragraph}><Text style={styles.bold}>Goals</Text> are collections of <Text style={styles.bold}>Passages</Text>.  Complete <Text style={styles.bold}>Lessons</Text> to learn verses and earn <Text style={styles.bold}>Peanuts</Text>.  Keep your <Text style={styles.bold}>Streak</Text> alive by earning <Text style={styles.bold}>Peanuts</Text> everyday.  When you have learned a verse, take a <Text style={styles.bold}>Test</Text> to earn <Text style={styles.bold}>Wrinkles</Text>.</Text>
              </View>
            ),
          },
          {
            question: 'Terminology', // @TODO: this could/should probably be combined with the "what are X?" questions?
            answer: (
              <View>
                <Text style={styles.paragraph}><Text style={styles.bold}>Goals: </Text>{"Comprised of one or more passages that you'd like to memorize, Goals are created to keep your verses organized."}</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>Passages: </Text>A passage is one or more verses (up to one chapter of the Bible).  Passages can be added to Goals.</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>Peanuts: </Text>{"Peanuts are awarded at the end of most lessons based on how many questions you answered correctly, the difficulty settings, and other variables.  They indicate how much you've been practicing."}</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>Wrinkles: </Text>{"A Wrinkle is another name for a memorized verse.  While Peanuts indicate how much practice you're getting, Wrinkles reflect the level of mastery of the Passages.  Wrinkles are earned after three successful tests and can continue to be leveled up after they are earned.  Each level up requires a longer waiting period between successful attempts to aid in long-term retention of the Passages."}</Text>
              </View>
            ),
            // @TODO: images
          },
          {
            question: 'Screens',
            answer: (
              <View>
                <Text style={styles.paragraph}><Text style={styles.bold}>Home: </Text>{"The main screen when you open Wrinkly has widgets for tracking progress and managing your goals.  Any tools that aren't on the Home screen should be accessible in the Side Menu."}</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>Lesson: </Text>Practice verses by playing games on the Lessons page.  Lessons can be started from any Passage.</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>Test: </Text>When you have learned a verse, take tests to earn and level up wrinkles.</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>Read: </Text>See memory verses in context, read any Bible passage, compare translations, and more on the Read page.</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>Discover: </Text>In addition to creating your own goals, you can also search for goals by topic or group.</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>Feedback Chat: </Text>Have a question, a feature request, or other feedback?  Messages can be sent and received here.</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>Settings: </Text>Your notification preferences and other settings like preferred translation and light/dark mode can be managed on this screen.</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>Fundraising and Groups: </Text>Part of a school, church, or organization that uses Wrinkly?  Fundraising campaigns and classrooms can be joined on these screens.</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>{"What's New: "}</Text>Learn about recent updates to Wrinkly.  New features and enhancements will be listed here.</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>Help: </Text>{"This is the page you're currently on.  Find information about common features and learn tips and tricks to make the most out of your experience with Wrinkly."}</Text>
                {isAnonymousUser && <Text style={styles.paragraph}><Text style={styles.bold}>Link Account: </Text>If you signed up with a guest account, your data will not be synced across devices.  To keep your progress, you can link your Wrinkly account to another account (Apple, Google, Facebook, or your email address).  This will allow you to recover your data if you lose your phone or want to sign in to Wrinkly on a new device.</Text>}
              </View>
            ),
            // @TODO: images
          },
        ],
      },
      {
        title: 'Goals',
        data: [
          {
            question: 'How do I create Goals?',
            answer: (
              <View>
                <Text style={styles.paragraph}>{'From the Side Drawer, press "All goals" and then the plus button in the bottom right to create a new goal.  Add a name and passages to get started!'}</Text>
                <Text style={styles.paragraph}>Goals can also be added from the Discover page.  Here you can find topical or group goals.</Text>
              </View>
            ),
            // @TODO: images
          },
          {
            question: 'How many goals should I create?  And how many passages should they have?',
            answer: (
              <View>
                <Text style={styles.paragraph}>{"How many active Goals you have or how many Passages to add is totally up to you and what you're hoping to get out of Wrinkly.  We recommend grouping similar Passages into the same Goal so that you're learning all of them at the same time, but you can create them however you learn best."}</Text>
                <Text style={styles.paragraph}>{"We recommend creating Goals with 1-5 Passages depending on how many verses each Passage has.  There's no magic number here, but smaller Goals tend to be more approachable, and when they're completed, you'll still be prompted to review what you've mastered while you move on to new Goals."}</Text>
              </View>
            ),
            // @TODO: images
          },
        ],
      },
      {
        title: 'Practice',
        data: [
          {
            question: 'What are the different types of practice?',
            answer: (
              <View>
                <Text style={styles.paragraph}>Changing the difficulty settings may change the number of verses displayed, how many clues are provide, etc.</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>Fill in the Blanks: </Text>Some of the words have been removed from the verse.  The missing words are scrambled in a word bank below and need to be put back in the correct order.</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>Order the Verses: </Text>Several verses are displayed on the screen in a random order.  Your goal is to rearrange the verses to put them back in the proper order.  (This game is available only for Passages with multiple verses.)</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>Quotes: </Text>Select the reference that matches the given verse.</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>First Letters: </Text>In this game, some of the words are missing all but the first few letters.  Finish the incomplete words to advance.</Text>
                {/* @TODO:
                <Text style={styles.paragraph}><Text style={styles.bold}>Attribution: </Text>{"If you're working on a Passage that contains a lot of dialog, this games helps you to remember who said what (and how).  Match the attribution (e.g. \"He said\", \"Jesus answered\", \"they replied\") with the dialog quote"}</Text>
                */}
              </View>
            ),
            // @TODO: images
          },
          {
            question: 'How do I practice more than one passage at a time?',
            answer: (
              <View>
                <Text style={styles.paragraph}>There are two icons in the top right of the Goal screen.  The first one opens up a selection menu that allows you to pick which passages to practice, which to review, and which to skip.  The second icon allows you to configure settings for the practice--the difficulty, games types, and the breakdown of questions asked for passages marked as practice/review.</Text>
              </View>
            ),
            // @TODO: images
          },
        ],
      },
      {
        title: 'Streaks',
        data: [
          {
            question: 'What are streaks?',
            answer: (
              <View>
                <Text style={styles.paragraph}>{"Your streak is a quick way to see on how many consecutive days you've made progress in Wrinkly.  Complete at least one lesson or test per day (at least one peanut must be earned) to continue your streak."}</Text>
              </View>
            ),
          },
          {
            question: 'What if I miss a day?  Will I lose my streak?',
            answer: (
              <View>
                <Text style={styles.paragraph}>{'We know how important keeping your streak can be to stay motivated and consistent to reach your goals.  Broken streaks can be repaired; if a day is missed, you have 10 days to make it up by earning additional peanuts.  From your Profile page, tap on the missing day in the streaks chart, and press the "Repair now" button to earn peanuts towards repair.  Note: repaired days do not count toward your streak, but they do prevent it from going back to zero.'}</Text>
              </View>
            ),
            // @TODO: images
          },
        ],
      },
      {
        title: 'Storms',
        data: [
          {
            question: 'What is a thunderstorm?',
            answer: (
              <View>
                <Text style={styles.paragraph}>{'When you fill up your storm radar ring, a thunderstorm starts in the jungle!  During storms, lessons earn double peanuts.'}</Text>
              </View>
            ),
          },
          {
            question: 'Can I turn off rain or lightning during storms?',
            answer: (
              <View>
                <Text style={styles.paragraph}>{'If any of the special effects are distracting, they can be turned off in the storm widget settings on the Home screen.'}</Text>
              </View>
            ),
            // @TODO: images
          },
        ],
      },
      /* @TODO:
      {
        title: 'Testing',
        data: [
          {
            question: 'TODO', // @TODO: explain srs
            answer: (
              <View>
                <Text style={styles.paragraph}>TODO</Text>
              </View>
            ),
            // @TODO: images
          },
        ],
      },
      */
      {
        title: 'Settings',
        data: [
          {
            question: 'How can I update my notification preferences?',
            answer: (
              <View>
                <Text style={styles.paragraph}>{'Notifications can be managed in the "Notification preferences" screen under Settings.  Here, you can toggle and set preferred times for notifications for streak reminders, passages of the day, friends, and more.'}</Text>{/* @TODO: link to notifications page */}
              </View>
            ),
          },
        ],
      },
      {
        title: 'Translations',
        data: [
          {
            question: 'Which translations are available in Wrinkly, and how do I change my preferred translation?',
            answer: (
              <View>
                <Text style={styles.paragraph}>{"The Settings screen lists all available translations, and you can pick your preferred translation here or from the Read screen.  If you don't see your preferred translation listed, please let us know via Feedback Chat."}</Text>
              </View>
            ),
          },
          {
            question: "Why does my Bible not match Wrinkly even though I'm using the same translation?",
            answer: (
              <View>
                <Text style={styles.paragraph}>{"Most major translators are constantly improving their Bible verses to create the most accurate texts they can, and most of the translations available within Wrinkly have gone through several revisions over the years, so if there's a difference between what you're seeing in Wrinkly and a print version, it's probably because the translation in Wrinkly is the most updated version.  However, if you find a mistake in the text, please let us know via Feedback Chat."}</Text>{/* @TODO: link to feedback chat */}
              </View>
            ),
          },
          {
            question: 'Why are some verses missing in my translation?',
            answer: (
              <View>
                <Text style={styles.paragraph}>{"In an effort to improve accuracy, some newer translations don't include all of the verses that are found in the oldest translations.  Early translations (like the King James Version) include verses that modern tranlsations consider to be additions either because of scribal errors or added clarification rather than part of the origanal texts.  These modern translations typically keep the original* verse numbers and simply skip these added verses."}</Text>
                <Text style={styles.paragraph}>Some translators also combine verses for easier translation.  This is especially common with the thought-for-thought translations where combining and summarizing several verses makes the text easier to read.</Text>
                <Text style={styles.paragraph}>*Verse numbers were not included in the original texts but were added centuries later.  However, those original chapter and verse divisions are still used by most major translators today.</Text>
                <Text style={styles.paragraph}>(Note: Only one wrinkle is earned per combined verse range; for example, if you memorize Genesis 7:5-7 CEV, only one wrinkle is eared because v5-7 have been combined into one verse.)</Text>
              </View>
            ),
          },
        ],
      },
      {
        title: 'Miscellaneous',
        data: [
          {
            question: 'Can I sync data between devices?',
            answer: (
              <View>
                <Text style={styles.paragraph}>{`${isAnonymousUser ? 'As long as you are not signed in as a guest' : 'Yes'}, data will be synced automatically between all devices you sign into with the same account.`}</Text>
                {isAnonymousUser && <Text style={styles.paragraph}>To link your guest account to an authentication provider, go to the Link Account screen (accessible via the Side Drawer) and link with Apple, Google, Facebook, or your email address.</Text>}
              </View>
            ),
          },
          {
            question: 'Why is it called "Wrinkly"?',
            answer: (
              <View>
                <Text style={styles.paragraph}>{'The initial idea came from the myth that your brain gets a new wrinkle every time you learn something new.  The elephant mascot was a natural fit since elephants are wrinkly, and they never forget!  (Plus, having wrinkly pages in your Bible means it must be getting a lot of use!)'}</Text>
              </View>
            ),
          },
          // @TODO: why is Scripture memory important -> add verses supporting this and redirect to Discover with the goal about the importance of memorizing in search
          {
            question: 'Do you have any study tips?',
            answer: (
              <View>
                <Text style={styles.paragraph}>{"The four most helpful tips we've discovered are the following:"}</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>1. </Text>Start your Wrinkly sessions by praying for God to teach you through His Word and asking Him to help you commit it to memory.</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>2. </Text>Consistency is key!  It is easier to retain long-term recall of something you work on for 5 minutes each day than it is to remember something that you work on for 35 minutes once a week.  Complete a lesson every day to keep your streak going and maximize your efforts.</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>3. </Text>When completing a lesson, it helps to say each word aloud.  Whether you are filling in blanks or typing incomplete words, speaking each word out loud as you practice helps to train your brain to remember the passages.</Text>
                <Text style={styles.paragraph}><Text style={styles.bold}>4. </Text>{"Keep in mind that spending time in God's Word is more important than points!  Earning peanuts and wrinkles are fun ways to stay motivated, but the Bible is infinitely more important!"}</Text>
              </View>
            ),
          },
          {
            question: "Does Wrinkly work if I'm offline?",
            answer: (
              <View>
                <Text style={styles.paragraph}>{"Yes, Wrinkly works when you are not connected to the internet.  Any lessons or assignments completed offline will be synced when you reconnect to the internet.  This includes keeping your streak alive and earning peanuts and wrinkles; any progress you make will be synced to your account when you're back online."}</Text>
                <Text style={styles.paragraph}>If you know that you will be offline, we recommend downloading an entire translation to ensure you have access to the whole Bible while disconnected from the internet.  Downloaded translations can be managed from the Settings page.</Text>
              </View>
            ),
          },
        ],
      },
      // @TODO: oakUser?.is_teacher && {
      /* @TODO:
      {
        title: 'Classrooms', // @TODO: this section should only be available to teachers and not public
        data: [
          {
            question: 'How can I prevent students from working ahead?',
            answer: (
              <View>
                <Text style={styles.paragraph}>Modules and assignments can both be given start and end dates.  When the availability date is set, the module or assignment name is visible to the student but cannot be worked on until the specified date.</Text>
                <Text style={styles.paragraph}>If you would like to hide assignments from students until the availability date, you may want to lock the modules instead of the assignments or pick assignment names that do not include the verse references.</Text>
              </View>
            ),
          },
          {
            question: 'Why do some of my students have completed assignments with no time?',
            answer: (
              <View>
                <Text style={styles.paragraph}>Most assignment types require lessons to be completed on the specific assignments you create (e.g. lectures, readings, and lesson-only verse memories).  However, verses can be memorized in many ways.  If a passage is marked as memorized but with a time of zero seconds, that likely indicates that the student memorized the passage in a goal outside of the classroom.  If it is marked as complete, the student has reached at least level 3 for all verses in the passage.</Text>
              </View>
            ),
          },
          {
            question: 'Why do some of my students have total times that are longer than the sum of the times spent on each assignment?',
            answer: (
              <View>
                <Text style={styles.paragraph}>The student progress table on the goal page shows the total time spent on any assignment for the current goal.  Clicking on the progress bar will show the time that student spent on each individual assignment, but the totals may not match due to the way lessons are linked to assignments.</Text>
                <Text style={styles.paragraph}>Students have the option to work on multiple passages during the same lesson, and when that happens, the lesson is associated with the goal but not an individual assignment.  Therefore, the time spent on that lesson is reflected in the total time in the student progress table but not in the per-assignment progress table.</Text>
              </View>
            ),
          },
        ],
      },
      {
        title: 'Fundraising',
        data: [
          // @TODO: how do funraisers work?
          // @TODO: how can i start a fundraiser for my organization?
          {
            question: 'As a participant, how do I earn money for my organization?',
            answer: (
              <View>
                <Text style={styles.paragraph}>Donors sponsor participants by pledging an amount per wrinkle earned.  Each memorized verse earns a wrinkle and is achieved by reaching level three for the verse.</Text>
                <Text style={styles.paragraph}>{"Each level requires successfully typing/reciting the verse with no mistakes.  (Small spelling mistakes don't count against you!)  At least 24 hours must pass between each successful level-up, so if the campaign deadline is coming up, be sure to leave a few days to finish earning your wrinkles!"}</Text>
              </View>
            ),
          },
          {
            question: 'As a participant, which verses should I memorize?',
            answer: (
              <View>
                <Text style={styles.paragraph}>Some organizations/campaigns have specific verses for participants to memorize.  If you are unsure, please check with your organization.</Text>
                <Text style={styles.paragraph}>If your organization does not have a specific list, you can create your own goals and select verses manually, or you can use the Discover feature to pick from a curated list of existing passages.</Text>
              </View>
            ),
          },
          {
            question: 'As a participant, how can I track my progress?',
            answer: (
              <View>
                <Text style={styles.paragraph}>Active campaigns are displayed on the Fundraising page in the mobile app.  From there you will be able to see how many wrinkles you have earned (level 3+) and how many are in-progress (level 1 or 2).</Text>
              </View>
            ),
          },
          {
            question: 'Can I be a sponsor and a participant?',
            answer: (
              <View>
                <Text style={styles.paragraph}>{"Yes!  Most campaigns are open to anyone, so if you would like to donate and also memorize verses, that's great!"}</Text>
              </View>
            ),
          },
          {
            question: 'As a sponsor, how do I know how much to pledge per verse?',
            answer: (
              <View>
                <Text style={styles.paragraph}>{"There's no \"right\" number, and average pledge amounts vary with the age and number of participants in the campaign.  If you don't know what to pick for your first campaign, we recommend $2 as a good starting point for the pledge and selecting a maximum donation amount (an amount that will not be exceeded, regardless of participation) that is right for you."}</Text>
              </View>
            ),
          },
          {
            question: 'As a sponsor, how do I follow a campaign?',
            answer: (
              <View>
                <Text style={styles.paragraph}>At the end of the campaign, sponsors will receive a summary of the participation and impact--how many lessons and verses were completed and how much of your pledge was met.  If you wish to add to your donation upon the conclusion of the campaign, you will have the opportunity to do so before final pledges are collected.</Text>
              </View>
            ),
          },
          //        {
          //          question: 'How does Wrinkly get verses to stick?',
          //          answer: (
          //            <View>
          //              <Text style={styles.paragraph}>{'To earn a wrinkle (i.e. for a verse to be considered "memorized"), users must complete 3 successful tests for the passage, and at least 24 hours must elapse between each test.  This prevents a user from reviewing a verse quickly and relying on short-term memory to pass the tests without committing anything to long-term memory.'}</Text>
          //            </View>
          //          ),
          //        },
          //        {
          //          question: 'As a sponsor, how do I know that participants are actually memorizing and not just typing in answers?',
          //          answer: (
          //            <View>
          //              <Text style={styles.paragraph}>{"Ultimately, without proctored tests, there is no way to verify if a participant is testing honestly or not.  However, entering the exact verse from the Bible during testing still requires time to be spent in the Word, so while it's something Wrinkly does not condone, it's still time well spent."}</Text>
          //            </View>
          //          ),
          //        },
        ],
      },
      */
      /* @TODO:
        section about oakwood:
          why did you create this? -> send them to about page
      */
      {
        ignoreInFaq: true,
        title: 'Quick Tips',
        data: [
          {text: 'Create your own goals, or use the Discover feature to pick from a curated list of existing passages.', onPress: () => navigation.navigate(DISCOVER_ROUTE)},
          {text: 'Add friends and family to track progress and encourage each other towards your goals.', onPress: () => navigation.navigate(FRIENDS_ROUTE, {openTab: 'find'})},
          {text: 'Set daily goals and configure reminders to keep you on track.'},
          {text: 'Completing a lesson on the Passage of the Day earns bonus peanuts.'},
          {text: 'Wrinkly provides fundraising opportunities for schools, churches, summer camps, and other missional organizations.', onPress: () => Linking.openURL('https://wrink.ly/fundraising')},
          {text: 'Search for any passage, goal, or user by tapping the magnifying glass in the top right.'},
          {text: 'Weekly progress, streaks, and wrinkles can be tracked from your Profile page.', onPress: () => navigation.navigate(PROFILE_ROUTE)},
          {text: 'Have questions?  Search the Help page for answers to common inquiries.', onPress: () => navigation.navigate(HELP_ROUTE)},
          {text: 'Your default translation, notification preferences, and other account options can be modified from the Settings page.', onPress: () => navigation.navigate(SETTINGS_ROUTE)},
          {text: 'Miss a day?  Your streak can be repaired by completing extra lessons.  Tap on any repairable missed day in the streak graph on your Profile page.', onPress: () => navigation.navigate(PROFILE_ROUTE)},
          isAnonymousUser && {text: 'You can sync your progress across all of your devices by signing in with an aunthenication provider.', onPress: () => navigation.navigate(LINK_ACCOUNT_ROUTE)},
          !oakUser?.is_feedback_chat_disabled && {text: 'Have a question or an idea for a new feature?  Let us know in the Feedback Chat page.', onPress: () => navigation.navigate(FEEDBACK_CHAT_ROUTE)},
        ].filter(Boolean).map((data, number) => {
          return {
            question: `Tip #${number + 1}`,
            answer: (
              <TouchableOpacity
                disabled={!data.onPress}
                onPress={data.onPress}
              >
                <Text style={styles.paragraph}>{data.text}</Text>
              </TouchableOpacity>
            ),
            isQuickTip: true,
          };
        }),
      },
    ].filter(Boolean),
  };
};

export default faqs;
